import { i18n } from "../../../boot/i18n";
// import { store } from "../../../store";

export default {
  routes: [
    {
      name: "quote-new",
      path: "sales-leads/:salesLeadID/quotes/new",
      props: true,
      meta: {
        icon: "edit",
        title: i18n.global.t("New Quote"),
        crumbs: ["sales-leads", { name: "sales-lead-view", isDialog: true }],
      },
      component: () => import("pages/employee/QuoteEdit"),
    },
    {
      name: "quote-edit",
      path: "sales-leads/:salesLeadID/quotes/:quoteID/edit",
      props: true,
      meta: {
        icon: "edit",
        title: i18n.global.t("Edit Quote"),
        crumbs: ["sales-leads", { name: "sales-lead-view", isDialog: true }],
      },
      component: () => import("pages/employee/QuoteEdit"),
    },
    {
      name: "quote-view",
      path: "sales-leads/:salesLeadID/quotes/:quoteID",
      props: true,
      meta: {
        icon: "quote",
        title: i18n.global.tc("Quote"),
        crumbs: ["sales-leads", { name: "sales-lead-view", isDialog: true }],
      },
      component: () => import("pages/employee/QuoteView"),
    },
    {
      name: "quote-send",
      path: "sales-leads/:salesLeadID/quotes/:quoteID/send",
      props: true,
      meta: {
        icon: "send",
        title: i18n.global.t("Send Quote"),
        crumbs: [
          "sales-leads",
          { name: "sales-lead-view", isDialog: true },
          "quote-view",
        ],
      },
      component: () => import("pages/employee/QuoteSend"),
    },
    {
      name: "final-quote",
      path: "projects/:projectID/sales/:saleID/quotes/:salesLeadID/:quoteID",
      props: true,
      meta: {
        icon: "quote",
        title: i18n.global.tc("Quote"),
        crumbs: ["projects", "project-view", "sale-view"],
      },
      component: () => import("pages/employee/QuoteView"),
    },
    {
      name: "quote-change-order",
      path: "projects/:projectID/sales/:saleID/quotes/:salesLeadID/:quoteID/change-order",
      props: true,
      meta: {
        icon: "change_order",
        title: i18n.global.t("Change Order"),
        crumbs: ["projects", "project-view", "sale-view"],
      },
      component: () => import("pages/employee/QuoteChangeOrder"),
    },
  ],

  dialogs: [],
};
